import {
  WIRCreateJourneyStepsKeys,
  WIRInterventionOperationSectionKey,
  WIRInterventionOperationSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getInterventionOperationSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.congo) {
    return (
      (wir &&
        Object.keys(WIRInterventionOperationSections)
          .map(item => ({
            label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.CG_INTERVENTION_OPERATION,
          }))
          .filter(
            stepItem =>
              stepItem.label !== WIRInterventionOperationSections.wellHandover &&
              stepItem.label !== WIRInterventionOperationSections.servicePartnerPaRoleIdentification &&
              stepItem.label !== WIRInterventionOperationSections.regularPermitsReceived &&
              stepItem.label !== WIRInterventionOperationSections.assetStatusCheck &&
              stepItem.label !== WIRInterventionOperationSections.lessonsCaptured &&
              stepItem.label !== WIRInterventionOperationSections.capPortalUpdates &&
              stepItem.label !== WIRInterventionOperationSections.livePerformanceTracking &&
              stepItem.label !== WIRInterventionOperationSections.equipmentPersonnelSite &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverIntervStart &&
              stepItem.label !== WIRInterventionOperationSections.emergencyDrill &&
              stepItem.label !== WIRInterventionOperationSections.prepareTpfr &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverDtToFo &&
              stepItem.label !== WIRInterventionOperationSections.dailyReportDistributionList &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverFoToDt &&
              stepItem.label !== WIRInterventionOperationSections.wellControllChecklistIpad,
          )) ??
      []
    );
  } else if (country === CountryData.angola) {
    return (
      (wir &&
        Object.keys(WIRInterventionOperationSections)
          .map(item => ({
            label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.AG_INTERVENTION_OPERATION,
          }))
          .filter(
            stepItem =>
              stepItem.label !== WIRInterventionOperationSections.wellHandover &&
              stepItem.label !== WIRInterventionOperationSections.servicePartnerPaRoleIdentification &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverBackToOpsEnd &&
              stepItem.label !== WIRInterventionOperationSections.regularPermitsReceived &&
              stepItem.label !== WIRInterventionOperationSections.assetStatusCheck &&
              stepItem.label !== WIRInterventionOperationSections.lessonsCaptured &&
              stepItem.label !== WIRInterventionOperationSections.capPortalUpdates &&
              stepItem.label !== WIRInterventionOperationSections.livePerformanceTracking &&
              stepItem.label !== WIRInterventionOperationSections.equipmentPersonnelSite &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverIntervStart &&
              stepItem.label !== WIRInterventionOperationSections.emergencyDrill &&
              stepItem.label !== WIRInterventionOperationSections.prepareTpfr &&
              stepItem.label !== WIRInterventionOperationSections.wellControllChecklistIpad,
          )) ??
      []
    );
  } else if (country === CountryData.nigeria) {
    return (
      (wir &&
        Object.keys(WIRInterventionOperationSections)
          .map(item => ({
            label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.NG_INTERVENTION_OPERATION,
          }))
          .filter(
            stepItem =>
              stepItem.label !== WIRInterventionOperationSections.wellHandover &&
              stepItem.label !== WIRInterventionOperationSections.servicePartnerPaRoleIdentification &&
              stepItem.label !== WIRInterventionOperationSections.capPortalUpdates &&
              stepItem.label !== WIRInterventionOperationSections.prepareTpfr &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverDtToFo &&
              stepItem.label !== WIRInterventionOperationSections.dailyReportDistributionList &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverFoToDt &&
              stepItem.label !== WIRInterventionOperationSections.wellControllChecklistIpad,
          )) ??
      []
    );
  } else if (country === CountryData.iraq) {
    return (
      (wir && wir?.isUnplannedReactiveScope
        ? Object.keys(WIRInterventionOperationSections)
            .map(item => ({
              label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
              value: item,
              phase: WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION,
            }))
            .filter(
              stepItem =>
                stepItem.label !== WIRInterventionOperationSections.capPortalUpdates &&
                stepItem.label !== WIRInterventionOperationSections.prepareTpfr &&
                stepItem.label !== WIRInterventionOperationSections.regularPermitsReceived &&
                stepItem.label !== WIRInterventionOperationSections.wellHandoverDtToFo &&
                stepItem.label !== WIRInterventionOperationSections.dailyReportDistributionList &&
                stepItem.label !== WIRInterventionOperationSections.wellHandoverFoToDt &&
                stepItem.label !== WIRInterventionOperationSections.wellControllChecklistIpad,
            )
        : Object.keys(WIRInterventionOperationSections)
            .map(item => ({
              label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
              value: item,
              phase: WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION,
            }))
            .filter(
              stepItem =>
                stepItem.label !== WIRInterventionOperationSections.wellHandover &&
                stepItem.label !== WIRInterventionOperationSections.servicePartnerPaRoleIdentification &&
                stepItem.label !== WIRInterventionOperationSections.capPortalUpdates &&
                stepItem.label !== WIRInterventionOperationSections.prepareTpfr &&
                stepItem.label !== WIRInterventionOperationSections.assetStatusCheck &&
                stepItem.label !== WIRInterventionOperationSections.regularPermitsReceived &&
                stepItem.label !== WIRInterventionOperationSections.wellHandoverDtToFo &&
                stepItem.label !== WIRInterventionOperationSections.dailyReportDistributionList &&
                stepItem.label !== WIRInterventionOperationSections.wellHandoverFoToDt &&
                stepItem.label !== WIRInterventionOperationSections.wellControllChecklistIpad,
            /* istanbul ignore next */
            )) ?? []
    );
  } else if (country === CountryData.argentina) {
    return (
      (wir &&
        /* istanbul ignore next */
        Object.keys(WIRInterventionOperationSections)
          .map(item => ({
            label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_OPERATION,
          }))
          .filter(
            stepItem =>
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.wellHandover &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.servicePartnerPaRoleIdentification &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.capPortalUpdates &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.prepareTpfr &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.assetStatusCheck &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.regularPermitsReceived &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.wellHandoverDtToFo &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.dailyReportDistributionList &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.wellHandoverFoToDt &&
              /* istanbul ignore next */
              stepItem.label !== WIRInterventionOperationSections.wellControllChecklistIpad,
          )) ??
      []
    );
  } else {
    return (
      (wir &&
        Object.keys(WIRInterventionOperationSections)
          .map(item => ({
            label: WIRInterventionOperationSections[item as WIRInterventionOperationSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.INTERVENTION_OPERATION,
          }))
          .filter(
            stepItem =>
              stepItem.label !== WIRInterventionOperationSections.wellHandoverIntervStart &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverBackToOpsEnd &&
              stepItem.label !== WIRInterventionOperationSections.regularPermitsReceived &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverDtToFo &&
              stepItem.label !== WIRInterventionOperationSections.dailyReportDistributionList &&
              stepItem.label !== WIRInterventionOperationSections.wellHandoverFoToDt,
          )) ??
      []
    );
  }
};
